const CertificadoOrigenOptions = [
  {
    label: "Selecciona",
    value: '',
  },
  {
    label: "No Funge como certificado de origen",
    value: "0",
  },
  {
    label: "Funge como certificado de origen",
    value: "1",
  }
];

export default CertificadoOrigenOptions;